export default function DSA_BST() {
  return <div>DSA_BST Component</div>;
}
